export const Questions = 'link.com/12345';
export const autoSaveAnswers = 'save';
export const submitAssessment = 'submit';
